window.topFunction = function() {
    jQuery('body,html').animate({
        scrollTop: 0
    }, 800);
}
